import { DataOperations } from '../src/operations/DataOperations';
import ProductDataHandler from '../src/core/productDataHandler';

const dataOperations = new DataOperations();
export const productHandler = new ProductDataHandler();

export default dataOperations;
